<template>
  <div class="row">
    <div class="col-xl-4">
      <b-card header="Account Number Search" header-tag="h4" class="bg-default-card mb-3">
        <ValidationObserver ref="searchWorkerByAccNum" v-slot="{ handleSubmit }" slim>
          <form @submit.prevent="handleSubmit(search_worker_by_acc_num)">
            <p class="font-weight-bold mb-4">Use this tool to search for the worker with the given account number.</p>
            <ValidationProvider rules="required|decimal|max:8|min:8" v-slot="{errors, classes}" name="Account Number to Search" tag="div" class="form-group">
              <label class="form-label" for="ac_num">Account Number to Search for</label>
              <input type="text" v-model.trim="ac_num" id="ac_num" name="ac_num" class="form-input requiredField" :class="classes" autofocus>
              <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
            </ValidationProvider>
            <button class="btn orcaBtn w-100" type="submit">Search</button>
          </form>
        </ValidationObserver>
      </b-card>
    </div>
    <div class="col-lg-8">
      <b-card header="Results" header-tag="h4" class="bg-default-card mb-3">
        <h5 v-if="banks.length === 0" class="font-weight-bold">No Workers Found</h5>
        <div v-else>
          <div v-for="bank in banks" class="worker_results row ml-0 mr-0">
            <div class="col-lg-4">
              <h4 class="worker_res_name bp-color mb-0">{{ bank.worker.person.first_name }} {{ bank.worker.person.surname }}</h4>
              <p class="worker_res_sage_ref"><span class="font-weight-bold">Sage Ref : </span>{{ bank.worker.internal_finance_ref }}</p>
            </div>
            <div class="col-lg-6">
              <p class="worker_res_ac_num"><span class="font-weight-bold">Account Number : </span>{{ bank.account_number }}</p>
              <p class="worker_res_sort_code"><span class="font-weight-bold">Sort Code : </span>{{ bank.sort_code }}</p>
            </div>
            <div class="col-lg-2">
              <button class="btn orcaBtn view-btn mt-2 w-100" title="Worker Profile" @click="gotoProfile(bank.worker.id)">View</button>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
export default {
  name: 'account_number_search',
  data() {
    return {
      ac_num: "",
      banks: []
    }
  },
  methods: {
    search_worker_by_acc_num() {
      this.errors = {};
      axios.get(this.crmApiPath + 'finance/account_number_search', {params: {account_number: this.ac_num}}).then(res => {
        this.banks = res.data;
      })
    },
    gotoProfile(worker_id) {
      this.$store.commit('CURRENT_PROFILE_WORKER_ID', worker_id);
      this.$store.commit('SET_WORKER_TAB_INDEX', 0);
      this.$nextTick(() => {
        this.$router.push('/workers/profile');
        this.$tabs.refresh('/workers/profile', true)
      });
    }
  },
  watch: {},
}
</script>
<style scoped lang="scss">
.worker_results {
  background:    #eaeaea;
  margin-bottom: 20px;
  padding:       10px;

  .worker_res_ac_num, .worker_res_sort_code, .worker_res_sage_ref {
    //font-size: 1.05rem;
  }

  .worker_res_name {
    display: inline-block;
    width:   300px;
  }

  .worker_res_ac_num {
    display:       block;
    margin-bottom: 0;

    span {
      display: inline-block;
      width:   150px;
    }
  }

  .worker_res_sort_code {
    display:       block;
    margin-bottom: 0;

    span {
      display: inline-block;
      width:   150px;
    }
  }

  .worker_res_sage_ref {
    display:       inline-block;
    width:         220px;
    margin-bottom: 0;

    span {
      display: inline-block;
      width:   150px;
    }
  }
}
</style>
